<h1>Add New Unit</h1>
@if (gridForm) {
  <form [formGroup]="gridForm" (submit)="save()">
    <mat-form-field class="col-3">
      <mat-label>Unit ID</mat-label>
      <input
        matInput
        id="unitIDInput"
        required
        [formControlName]="'unitID'"
        [placeholder]="'Unit ID'"
        (keyup)="checkUnitId($event)"
      />
      @if (gridForm.controls['unitID'].hasError('required')) {
        <mat-error>This field is required</mat-error>
      }
      @if (gridForm.controls['unitID'].hasError('notUnique')) {
        <mat-error>This ID already exists</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="col-3">
      <mat-label>Unit Name</mat-label>
      <input
        matInput
        id="unitNameInput"
        required
        [formControlName]="'unitName'"
        [placeholder]="'Unit Name'"
      />
      @if (gridForm.controls['unitName'].hasError('notUnique')) {
        <mat-error>This Name already exists</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="col-3">
      <mat-label>Unit Type</mat-label>
      <input
        matInput
        id="unitTypeInput"
        required
        [formControlName]="'unitType'"
        [placeholder]="'Unit Type'"
      />
      <mat-error>This field is required</mat-error>
    </mat-form-field>
    <mat-form-field class="col-3">
      <mat-label>Parent Unit</mat-label>
      <mat-select
        id="parentUnitSelect"
        required
        [formControlName]="'parentUnit'"
        [placeholder]="'Parent Unit'"
      >
        @for (parent of units; track parent.name) {
          <mat-option [value]="parent.name">{{ parent.name }}</mat-option>
        }
      </mat-select>
      <mat-error>This field is required</mat-error>
    </mat-form-field>
    <div class="col-12 mb-5">
      <button mat-raised-button class="pull-right" color="accent" type="submit">
        Save
      </button>
      <button mat-raised-button class="pull-right me-2" (click)="cancel()">
        Cancel
      </button>
    </div>
  </form>
}
